//表单数据
export const formData = {
  liveAdvanceNoticeId:'',
  contents: '',
  remark: '',
  photo: '',
  
}

//表单验证规则
export const formRules = {
  contents: [{ required: true, message: "正文不能为空", trigger: "blur" }],
 
}